module.exports = __webpack_public_path__ + "img/font-awesome-flag.8e551604.svg";